<template>
    <CompassTable class="table-loading">
        <CompassTableHead class="table-loading__head">
            <CompassTableHeadCell v-for="column in 4" :key="column" />
        </CompassTableHead>
        <CompassTableBody>
            <CompassTableRow v-for="row in 5" :key="row">
                <CompassTableBodyCell maxWidth="48px" minWidth="48px">
                    <CompassSkeleton variant="square" />
                </CompassTableBodyCell>
                <CompassTableBodyCell maxWidth="190px" minWidth="190px">
                    <CompassSkeleton />
                </CompassTableBodyCell>
                <CompassTableBodyCell maxWidth="260px" minWidth="260px">
                    <CompassSkeleton />
                </CompassTableBodyCell>
                <CompassTableBodyCell>
                    <CompassSkeleton />
                </CompassTableBodyCell>
            </CompassTableRow>
        </CompassTableBody>
    </CompassTable>
</template>

<style scoped lang="scss">
.table-loading {
    &__head {
        display: none;
    }
    :deep() {
        .compass-table__cell-container,
        .compass-skeleton {
            width: 100%;
        }
        .compass-table-body__row:hover > .compass-table__cell {
            background-color: var(--colors-common-background-default);
        }
    }
}
</style>
